import { render, staticRenderFns } from "./EnvLabel.vue?vue&type=template&id=a74e4d86&scoped=true&"
import script from "./EnvLabel.vue?vue&type=script&lang=js&"
export * from "./EnvLabel.vue?vue&type=script&lang=js&"
import style0 from "./EnvLabel.vue?vue&type=style&index=0&id=a74e4d86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74e4d86",
  null
  
)

export default component.exports